<app-modal *ngIf="vo$ | async; let vo" class="app-depot-change-version-modal">
    <div modal-body
        class="app-depot-change-version-modal__body"
        *ngIf="vo$ | async as vo"
        (keyup.enter)="onSave()">

				<dc-alert
					class="info"
					type="warning"
					message="info"
					i18n-message="@@depot.changeVersion.modal.description">
				</dc-alert>

				<div class="app-depot-change-version-modal__content">
					<div class="datalink-label">
						<div class="label-view">
						<span
							i18n="@@depot.changeVersion.modal.dataLinkLabel">
							datalink-label</span>
						</div>
						<div class="value-view">
							{{ vo.depot.dataLinkLabel }}
						</div>
					</div>

					<div class="current-version">
						<div class="label-view">
						<span
							i18n="@@depot.changeVersion.modal.currentVersion">
							current-version
						</span>
						</div>
						<div class="value-view">
							{{ vo.depot.currentVersion }}
						</div>
					</div>

					<div class="new-version">
						<label class="label-view" for="version-select">
						<span
							i18n="@@depot.changeVersion.modal.newVersion">
							new-version
						</span>
						</label>
						<div class="value-view">
							<mat-form-field [appearance]="Appearance">
								<mat-select id="version-select"
														[formControl]="versionControl"
														(selectionChange)="onVersionChange($event)">
									<mat-option
										*ngFor="let opt of vo.availableVersions | toArray"
										[value]="opt.id">
										{{ opt.version }}</mat-option>
								</mat-select>
								<mat-error i18n="@@general.form.errors.required">
									is-required
								</mat-error>
							</mat-form-field>
						</div>
					</div>

					<div class="current-headers">
						<div class="legend">
							<div class="legend__indicator">
								<div class="rect is-added"></div>
								<span class="legend__label"
											i18n="@@depot.changeVersion.modal.legend.headerAdded">
										header-added</span>
							</div>
							<div class="legend__indicator">
								<div class="rect is-removed"></div>
								<span class="legend__label"
											i18n="@@depot.changeVersion.modal.legend.headerRemoved">
										removed-header</span>
							</div>
						</div>
						<div class="headers">
							<div class="headers-title">
							<span
								i18n="@@depot.changeVersion.modal.legend.currentHeaders">
								current-headers</span>
								<app-badge>{{vo.currentVersionColumnsPreview.size}}</app-badge>
							</div>
							<div class="headers-body">
								<ng-container *ngFor="let col of vo.currentVersionColumnsPreview | toArray">
									<div class="header-item" [class.row-deleted]="vo.selectedVersion && !vo.selectedVersion.columns.has(col.uuid)">
										<app-column-type
											[type]="col['type']"
											[isList]="col['isList']"></app-column-type>
										<span>{{ col.label }}</span>
									</div>
								</ng-container>
							</div>
						</div>
					</div>

					<div class="new-headers">
						<div class="headers">
							<div class="headers-title">
						<span
							i18n="@@depot.changeVersion.modal.legend.newHeaders">
								new-headers</span>
								<app-badge *ngIf="vo.selectedVersion">{{vo.selectedVersion.columns.size}}</app-badge>
							</div>
							<div class="headers-body">
								<ng-container *ngIf="vo.selectedVersion; else noSelection">
									<ng-container *ngFor="let col of vo.selectedVersion.columns | toArray">
										<div class="header-item" [class.row-added]="!vo.currentVersionColumnsPreview.has(col.uuid)">
											<app-column-type
												[type]="col['type']"
												[isList]="col['isList']"></app-column-type>
											<span>{{ col.label }}</span>
										</div>
									</ng-container>
								</ng-container>

								<ng-template #noSelection>
									<div class="empty-selection">
										<mat-icon [svgIcon]="DcIcons.SwitchVersion"></mat-icon>
										<div class="empty-selection-description">
									<span
										i18n="@@depot.changeVersion.modal.legend.newHeaders.noSelection">
										no-selection</span>
											<small
												i18n="@@depot.changeVersion.modal.legend.newHeaders.noSelection.description">
												description</small>
										</div>
									</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
    </div>

    <div modal-footer class="app-depot-change-version-modal__footer">
			<app-button
				[attr.data-disabled]="!vo.selectedVersion || vo.isLoading"
				id="{{ cmpId }}-save-btn"
				[isInProgress]="vo.isLoading"
				[isDisabled]="!vo.selectedVersion || vo.isLoading"
				[loaderSize]="15"
				(click)="onSave()"
				i18n="@@general.action.save">
				save</app-button>
    </div>
</app-modal>
